import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const WorkIcon = (props: SvgIconProps) => (
  <SvgIcon
    width="28"
    height="28"
    viewBox="0 0 28 28"
    sx={{ fill: 'none' }}
    {...props}
  >
    <path
      d="M13.9987 23.3332C12.2251 22.2952 10.2133 21.7488 8.16536 21.7488C6.11744 21.7488 4.10559 22.2952 2.33203 23.3332V6.25091C4.10559 5.21295 6.11744 4.6665 8.16536 4.6665C10.2133 4.6665 12.2251 5.21295 13.9987 6.25091M13.9987 23.3332C15.7723 22.2952 17.7841 21.7488 19.832 21.7488C21.88 21.7488 23.8918 22.2952 25.6654 23.3332V6.25091C23.8918 5.21295 21.88 4.6665 19.832 4.6665C17.7841 4.6665 15.7723 5.21295 13.9987 6.25091M13.9987 23.3332V6.25091"
      stroke="white"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
